module.exports = __webpack_public_path__ + "img/02.9df7f0ff.png";